// AUTO GENERATED FILE BY @kalissaac/prisma-typegen
// DO NOT EDIT

export enum TagType {
	AUTO = 'AUTO',
	STUDENT = 'STUDENT',
}

export enum StudentState {
	WAITING_FOR_ADMISSION = 'WAITING_FOR_ADMISSION',
	NOT_STARTED = 'NOT_STARTED',
	IN_PROGRESS = 'IN_PROGRESS',
	FINISHED = 'FINISHED',
	TO_EXAM = 'TO_EXAM',
	EXAM_CORRECTION = 'EXAM_CORRECTION',
	DONE = 'DONE',
	STORNO = 'STORNO',
}

export enum StudentLogType {
	NOT_STARTED = 'NOT_STARTED',
	IN_PROGRESS = 'IN_PROGRESS',
	FINISHED = 'FINISHED',
	TO_EXAM = 'TO_EXAM',
	EXAM_CORRECTION = 'EXAM_CORRECTION',
	DONE = 'DONE',
	STORNO = 'STORNO',
}

export enum ExamType {
	PSP = 'PSP',
	PJ = 'PJ',
	OUV = 'OUV',
	CV = 'CV',
}

export enum DrivingLessonRecordType {
	PV_UV = 'PV_UV',
	PV_ZP = 'PV_ZP',
	DRIVING = 'DRIVING',
}

export enum TrainingType {
	BASIC = 'BASIC',
	EXPANDING = 'EXPANDING',
	ASSOCIATED = 'ASSOCIATED',
	COMPLEMENTARY = 'COMPLEMENTARY',
}

export enum TrainingTypeExtended {
	ISP = 'ISP',
	COURSE = 'COURSE',
	VRP = 'VRP',
}

export enum StudentGroup {
	B = 'B',
	Ba = 'Ba',
	B96 = 'B96',
	BpE = 'BpE',
	AM = 'AM',
	A1 = 'A1',
	A2 = 'A2',
	A = 'A',
	C = 'C',
	CpE = 'CpE',
	D = 'D',
	DpE = 'DpE',
	T = 'T',
	C1 = 'C1',
	C1pE = 'C1pE',
	D1 = 'D1',
	D1pE = 'D1pE',
	B1 = 'B1',
}

export enum AssistantGroup {
	PV_ZP = 'PV_ZP',
	ZP = 'ZP',
}

export enum ExamResult {
	SUCCESS = 'SUCCESS',
	FAIL = 'FAIL',
	DID_NOT_TAKE_PLACE = 'DID_NOT_TAKE_PLACE',
}

export enum GroupTier {
	STARTER = 'STARTER',
	PREMIUM = 'PREMIUM',
	ENTERPRISE = 'ENTERPRISE',
}

export enum UserInSchoolType {
	ADMIN = 'ADMIN',
	TEACHER = 'TEACHER',
	ASSISTANT = 'ASSISTANT',
	PARAMEDIC = 'PARAMEDIC',
}

export enum GroupRoleType {
	ADMIN = 'ADMIN',
	USER = 'USER',
}

export enum GroupTierPeriod {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	YEARLY = 'YEARLY',
}

export enum SystemTaskType {
	REMOVE_TEST_USERS = 'REMOVE_TEST_USERS',
	FETCH_BANK_TRANSACTIONS = 'FETCH_BANK_TRANSACTIONS',
	PDF_GENERATION = 'PDF_GENERATION',
	DROP_CACHE_FULL = 'DROP_CACHE_FULL',
	DAILY_CHECK_TIERS = 'DAILY_CHECK_TIERS',
	DAILY_FETCH_EXTERNAL_SCHOOL_COMPANIES = 'DAILY_FETCH_EXTERNAL_SCHOOL_COMPANIES',
	REGENERATE_INVOICE_PDF = 'REGENERATE_INVOICE_PDF',
	EMAIL_STUDENT_PASS_CODE = 'EMAIL_STUDENT_PASS_CODE',
	REMOVE_USER_LAST_SEARCHES = 'REMOVE_USER_LAST_SEARCHES',
}

export enum PdfFileType {
	REPORT = 'REPORT',
	INVOICE = 'INVOICE',
	EXAM = 'EXAM',
	REPORT_VEHICLE_DRIVING_TRAINING = 'REPORT_VEHICLE_DRIVING_TRAINING',
	REPORT_CLASS_BOOK = 'REPORT_CLASS_BOOK',
}

export enum PdfFileStatus {
	NEW = 'NEW',
	PROCESSING = 'PROCESSING',
	DONE = 'DONE',
	ERROR = 'ERROR',
}

export enum DrivingLessonRecordState {
	SCHEDULED = 'SCHEDULED',
	COMPLETED = 'COMPLETED',
	CANCELLED_BY_STUDENT = 'CANCELLED_BY_STUDENT',
	CANCELLED_BY_TEACHER = 'CANCELLED_BY_TEACHER',
}

export enum StudentDefaultTeacherType {
	TEACHING = 'TEACHING',
	TRAINING = 'TRAINING',
}

export enum NotificationType {
	UNPAID_GROUP = 'UNPAID_GROUP',
	GENERIC = 'GENERIC',
}

export enum ConfigType {
	ACTION_TIER_CONFIG = 'ACTION_TIER_CONFIG',
}

export enum TeachingLessonRecordType {
	PPV = 'PPV',
	OUV = 'OUV',
	TZBJ = 'TZBJ',
	ZP = 'ZP',
	OP = 'OP',
}

export enum UserLastSearchEntityType {
	STUDENT = 'STUDENT',
}

export interface User {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	firstName: string;
	lastName: string;
	email: string;
	phone?: string;
	password: string;
	isActivated: boolean;
	schools: UsersInSchools[];
	emailConfirmCodes: EmailConfirmCode[];
	ResetPasswordCodes: ResetPasswordCode[];
	activeSchoolId: string;
	activeSchool: School;
	isDeleted: boolean;
	userFeatureFlags: UserHasUserFeatureFlag[];
	drivingLessonsRecord: DrivingLessonRecord[];
	googleAuth: UserGoogleAuth[];
	defaultTeachers: StudentDefaultTeacher[];
	userSettings?: UserSettings;
	userRights?: UserRights;
	groupRoles: GroupRole[];
	userInSchoolRole: UserInSchoolRole[];
	notifications: Notification[];
	teachingLessonsRecord: TeachingLessonRecord[];
	userLastSearches: UserLastSearch[];
	userRefreshTokens: UserRefreshToken[];
	userActivityLogs: UserActivityLog[];
	carReservations: CarReservation[];
}

export interface UserRefreshToken {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	token: string;
	userId: string;
	user: User;
}

export interface UserActivityLog {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	ip: string;
	userAgent: string;
	type: string;
	userId: string;
	user: User;
}

export interface UserGoogleAuth {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	refreshToken: string;
	accessToken: string;
	email: string;
	expireDate: Date;
	tokenType: string;
	scope: string;
	idToken: string;
	error?: string;
	user: User;
	userId: string;
}

export interface Group {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	schools: School[];
	groupRoles: GroupRole[];
	pdfFiles: PdfFile[];
	settings?: GroupSettings;
	itemTiers: GroupItemTier[];
	isBlocked: boolean;
}

export interface GroupSettings {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	groupId: string;
	group: Group;
	maxStudentsInSchoolPerMonth: number;
	maxTeachersInSchool: number;
	maxSchools: number;
	tier: GroupTier;
	nextPeriodPeriod: GroupTierPeriod;
	nextPeriodPrice: number;
	overridePeriodSettings: boolean;
	unpaidPeriodDays: number;
	toPaidPeriod: number;
	meta?: any;
}

export interface GroupItemTier {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	groupId: string;
	group: Group;
	pdfFileId?: string;
	fromDate: Date;
	toDate: Date;
	toPaidDate: Date;
	toBlockDate: Date;
	tier: GroupTier;
	price: number;
	invoiceNumber: string;
	isPaid: boolean;
	isEnded: boolean;
	isBlocked: boolean;
	isFakePayment: boolean;
	isChecked: boolean;
	groupItemTierReport: GroupItemTierReport[];
}

export interface GroupItemTierReport {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	groupItemTierId: string;
	groupItemTier: GroupItemTier;
	userId: string;
	type: string;
}

export interface GroupTierPrice {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	period: GroupTierPeriod;
	tier: GroupTier;
	unpaidPeriodDays: number;
	toPaidPeriod: number;
	price: number;
	actionPrice?: number;
	actionPriceMonth?: number;
}

export interface GroupRole {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	groupId: string;
	group: Group;
	role: GroupRoleType;
}

export interface School {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	students: Student[];
	users: UsersInSchools[];
	exams: Exam[];
	interpreters: Interpreter[];
	schoolAddress?: SchoolAddress;
	schoolOperator?: SchoolOperator;
	schoolInfo?: SchoolInfo;
	schoolCar: SchoolCar[];
	reports: Report[];
	office?: Office;
	officeId?: string;
	drivingLessonsRecord: DrivingLessonRecord[];
	activeUser: User[];
	invites: SchoolInvite[];
	paymentItems: PaymentItem[];
	applicationForm: ApplicationForm[];
	teachingLessonsRecord: TeachingLessonRecord[];
	carReservations: CarReservation[];
	group: Group;
	groupId: string;
	schoolCode?: SchoolCode;
	apiKey?: ApiKey;
	tags: Tag[];
}

export interface SchoolCode {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	code: string;
	schoolId: string;
	school: School;
}

export interface ApiKey {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	key: string;
	schoolId: string;
	school: School;
}

export interface SchoolInvite {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	email: string;
	code: string;
	sendCounter: number;
	firstName: string;
	lastName: string;
	phone?: string;
	schoolId: string;
	school: School;
	meta?: any;
	isUsed: boolean;
	isDeclined: boolean;
}

export interface SchoolAddress {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	street: string;
	streetCode: string;
	city: string;
	postCode: string;
	schoolId: string;
	school: School;
}

export interface SchoolOperator {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	street: string;
	streetCode: string;
	city: string;
	postCode: string;
	companyNumber: string;
	name: string;
	schoolId: string;
	school: School;
}

export interface SchoolInfo {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	number: string;
	numberOfTeachers?: string;
	numberPrague?: string;
	schoolId: string;
	school: School;
}

export interface SchoolCar {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	carType: string;
	regNumber: string;
	targetGroup: StudentGroup[];
	schoolId: string;
	school: School;
	drivingLessonsRecord: DrivingLessonRecord[];
	carReservations: CarReservation[];
}

export interface UsersInSchools {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	schoolId: string;
	school: School;
	userInSchoolRole?: UserInSchoolRole;
}

export interface UserInSchoolRole {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	usersInSchoolsId: string;
	usersInSchools: UsersInSchools;
	role: UserInSchoolType;
	teacherTeaching: StudentGroup[];
	teacherTraining: StudentGroup[];
	assistantTeaching: AssistantGroup[];
	assistantTraining: AssistantGroup[];
}

export interface Student {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	registrationNumber: string;
	state: StudentState;
	dateOfInProgress?: Date;
	dateOfFinished?: Date;
	schoolId: string;
	school: School;
	studentAddress?: StudentAddress;
	studentInfo?: StudentInfo;
	studentStudyInfo?: StudentStudyInfo;
	exams: StudentOnExam[];
	reports: StudentOnReport[];
	logs: StudentLog[];
	drivingLessonsRecord: DrivingLessonRecord[];
	paymentItems: PaymentItem[];
	isDeleted: boolean;
	defaultTeachers: StudentDefaultTeacher[];
	teachingLessonsRecord: TeachingLessonRecord[];
	studentInterpreter?: StudentInterpreter;
	studentCode?: StudentCode;
	studentPassSignature?: StudentPassSignature;
}

export interface StudentPassSignature {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	signature?: string;
	studentId: string;
	student: Student;
}

export interface StudentInterpreter {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	studentId: string;
	student: Student;
	interpreterId: string;
	interpreter: Interpreter;
}

export interface StudentCode {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	code: string;
	studentId: string;
	student: Student;
}

export interface StudentDefaultTeacher {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	studentId: string;
	student: Student;
	userId: string;
	user: User;
	type: StudentDefaultTeacherType;
}

export interface StudentAddress {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	studentId: string;
	student: Student;
	street: string;
	streetCode: string;
	city: string;
	postCode: string;
}

export interface StudentStudyInfo {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	group: StudentGroup[];
	currentGroups: StudentGroup[];
	trainingType: TrainingType;
	trainingTypeExtended: TrainingTypeExtended;
	carIdNumber?: string;
	note?: string;
	studentId: string;
	student: Student;
}

export interface StudentInfo {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	firstName: string;
	lastName: string;
	degree?: string;
	birthDate: Date;
	birthPlace: string;
	citizenship: string;
	docId: string;
	phone?: string;
	email?: string;
	interpreter?: string;
	studentId: string;
	student: Student;
}

export interface StudentLog {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	type: StudentLogType;
	date: Date;
	studentId: string;
	student: Student;
	meta?: any;
}

export interface EmailConfirmCode {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	isUsed: boolean;
	code: string;
}

export interface Exam {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	date: Date;
	type: ExamType[];
	place?: string;
	registrationNumber: string;
	isDeleted: boolean;
	schoolId: string;
	school: School;
	students: StudentOnExam[];
}

export interface StudentOnExam {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	type: ExamType;
	result?: ExamResult;
	group: StudentGroup;
	note?: string;
	studentId: string;
	student: Student;
	examId: string;
	exam: Exam;
}

export interface Report {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	registrationNumber: string;
	date: Date;
	dateKey: string;
	schoolId: string;
	school: School;
	students: StudentOnReport[];
	isDeleted: boolean;
}

export interface StudentOnReport {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	note?: string;
	studentId: string;
	student: Student;
	reportId: string;
	report: Report;
}

export interface Office {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	type: string;
	street: string;
	streetCode: string;
	city: string;
	postCode: number;
	schools: School[];
}

export interface ResetPasswordCode {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	code: string;
	isUsed: boolean;
	userId: string;
	user: User;
}

export interface ContactMessage {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	email: string;
	message: string;
	solved: boolean;
}

export interface UserFeatureFlag {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	isForceEnabled: boolean;
	isForceDisabled: boolean;
	users: UserHasUserFeatureFlag[];
}

export interface UserHasUserFeatureFlag {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	userFeatureFlagId: string;
	userFeatureFlag: UserFeatureFlag;
}

export interface DrivingLessonRecord {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	type: DrivingLessonRecordType;
	startTime: Date;
	endTime: Date;
	length?: number;
	schoolCarId?: string;
	schoolCar?: SchoolCar;
	schoolId: string;
	school: School;
	studentId: string;
	student: Student;
	userId?: string;
	user?: User;
	tachometerBefore?: number;
	tachometerAfter?: number;
	signature?: string;
	teacherSignature?: string;
	googleCalendarEventId?: string;
	state: DrivingLessonRecordState;
}

export interface TeachingLessonRecord {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	type: TeachingLessonRecordType;
	date?: Date;
	schoolId?: string;
	school?: School;
	studentId: string;
	student: Student;
	userId?: string;
	user?: User;
	topic?: string;
}

export interface CarReservation {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	schoolCarId: string;
	schoolCar: SchoolCar;
	note?: string;
	userId: string;
	user: User;
	schoolId: string;
	school: School;
	startTime: Date;
	endTime: Date;
}

export interface PaymentItem {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	note?: string;
	price: number;
	studentId: string;
	Student: Student;
	schoolId: string;
	School: School;
}

export interface UserSettings {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	allowGoogleCalendarDrivingLessons: boolean;
}

export interface UserRights {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	training: any;
	teaching: any;
	medicalPreparation: any;
}

export interface SystemTask {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	type: SystemTaskType;
	meta?: any;
}

export interface ApplicationForm {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	origins: string[];
	key: string;
	schoolId: string;
	school: School;
	colorPrimary: string;
	colorError: string;
	applicationFormVisit: ApplicationFormVisit[];
	courses: ApplicationFormCourse[];
}

export interface ApplicationFormVisit {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	applicationFormId: string;
	applicationForm: ApplicationForm;
	ip: string;
}

export interface ApplicationFormCourse {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	description: string;
	price: number;
	applicationFormId: string;
	applicationForm: ApplicationForm;
}

export interface BankTransaction {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	metaData: any;
	updateCounter: number;
	hash: string;
}

export interface PdfFile {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	fileUrl?: string;
	groupId: string;
	group: Group;
	userId: string;
	meta?: any;
	type: PdfFileType;
	status: PdfFileStatus;
}

export interface Notification {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	meta?: any;
	type: NotificationType;
	groupId?: string;
	isRead: boolean;
}

export interface Config {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	type: ConfigType;
	meta: any;
}

export interface ExternalSchoolCompanyCrawled {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	ico: string;
	name: string;
	dateOfCreate: Date;
	dateOfUpdate: Date;
	address: string;
	solved: boolean;
	note?: string;
}

export interface Interpreter {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	interpreterInfo?: InterpreterInfo;
	interpreterAddress?: InterpreterAddress;
	isDeleted: boolean;
	schoolId: string;
	school: School;
	studentInterpreter: StudentInterpreter[];
}

export interface InterpreterInfo {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	firstName: string;
	lastName: string;
	degree?: string;
	birthDate: Date;
	phone: string;
	interpreterId: string;
	interpreter: Interpreter;
}

export interface InterpreterAddress {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	street: string;
	streetCode: string;
	city: string;
	postCode: string;
	interpreterId: string;
	interpreter: Interpreter;
}

export interface UserLastSearch {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	userId: string;
	user: User;
	entityId: string;
	entityType: UserLastSearchEntityType;
	schoolId: string;
}

export interface Tag {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	color: string;
	schoolId: string;
	school: School;
	tagAssociations: TagAssociation[];
}

export interface TagAssociation {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	tagId: string;
	tag: Tag;
	entityId: string;
	entityType: TagType;
}
